var map = {
	"./level_apple.json": "534a",
	"./level_apricot.json": "d774",
	"./level_avocado.json": "485c",
	"./level_banana.json": "4ef0",
	"./level_blueberry.json": "bd27",
	"./level_cantaloupe.json": "d051",
	"./level_cherry.json": "e952",
	"./level_clementine.json": "090c",
	"./level_coconut.json": "77d4",
	"./level_cranberry.json": "7cce",
	"./level_cucumber.json": "1990",
	"./level_dragonfruit.json": "81af",
	"./level_eggplant.json": "0d93",
	"./level_fig.json": "b7d7",
	"./level_grape.json": "e159",
	"./level_guava.json": "a68c",
	"./level_honeydew.json": "eb91",
	"./level_jackfruit.json": "0446",
	"./level_kiwi.json": "17d6",
	"./level_lemon.json": "c0bb",
	"./level_lime.json": "1fde",
	"./level_mandarine.json": "ed85",
	"./level_mango.json": "69b5",
	"./level_nectarine.json": "2f82",
	"./level_olive.json": "d6e2",
	"./level_orange.json": "7b2a",
	"./level_papaya.json": "cbfd",
	"./level_pepper.json": "5122"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5db0";